import React from "react";
import StatusProgressLadder from "@/components/StatusProgressLadder";
import { STATUS_LIST, STATUS } from "@/lib/utils-app";
import { friendlyStatus } from "@/lib/citizen";

/**
 * Visar status-sektion: medborgar-vänlig ladder för users,
 * admin-knappar för handläggare.
 */
export default function CaseStatusBlock({ c, user, onChangeStatus }) {
  if (user?.role === "admin") {
    return (
      <div className="mt-6 p-4 bg-zinc-50 border border-zinc-200 rounded-sm">
        <div className="text-xs font-semibold uppercase tracking-wider text-zinc-500 mb-2">Ändra status</div>
        <div className="flex flex-wrap gap-2">
          {STATUS_LIST.map((s) => (
            <button
              key={s}
              data-testid={`status-set-${s}`}
              onClick={() => onChangeStatus(s)}
              disabled={c.status === s}
              className={`px-3 py-1.5 text-xs font-medium border rounded-sm transition ${
                c.status === s ? "bg-zinc-900 text-white border-zinc-900" : "bg-white border-zinc-300 hover:bg-zinc-100"
              }`}
            >
              {STATUS[s].label}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="mt-6 p-5 bg-zinc-50 border border-zinc-200 rounded-sm" data-testid="citizen-status-block">
      <StatusProgressLadder status={c.status} />
      <div className="mt-6 pt-5 border-t border-zinc-200">
        <div className="text-base font-medium text-zinc-900">{friendlyStatus(c.status).label}</div>
        <p className="mt-1 text-sm text-zinc-600">{friendlyStatus(c.status).description}</p>
        {c.status === "komplettering" && (
          <div className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 bg-amber-50 border border-amber-200 text-amber-900 text-xs font-medium rounded-sm">
            Läs senaste meddelandet från handläggaren nedan eller ladda upp efterfrågade handlingar.
          </div>
        )}
        <div className="mt-3 text-xs text-zinc-500">
          Genomsnittlig handläggningstid: <span className="font-medium text-zinc-700">8 veckor från komplett ansökan</span>
        </div>
      </div>
    </div>
  );
}
